module.exports = __webpack_public_path__ + "img/age-confirm-main-img.06d0e37a.png";